import flags from "@utils/constants/flags";

export const useFlagEmojis = () => {
  const dertermineFlag = (country) => {
    const unicode = flags[country] ?? "1f1eb-1f1f7";
    return unicode
      .split("-")
      .map((hex) => String.fromCodePoint(parseInt(hex, 16)))
      .join("");
  };

  return dertermineFlag;
};
